/*globals Dialog*/
'use strict';

angular.module('MW.Influencers.IcmDialogService', ['ladda']).factory('DialogService', ['$translate', '$timeout', '$q', function($translate, $timeout, $q) {

    var currentFlashMessageId = 0,
        serviceObj = {};

    serviceObj.flashMessages = [];
    serviceObj.currentDialog = null;
    serviceObj.showBackground = true;
    serviceObj.dialogType = 'alert';
    serviceObj.dialogChanging = [];
    serviceObj.mainDialog= {};

    serviceObj.getCurrentDialog = function(){
        return serviceObj.currentDialog;
    };

    serviceObj.registerDialogChanging = function(observer){
        serviceObj.dialogChanging.push(observer);
    };

    serviceObj.alert  = function(alertMessageText, alertMessageTitle, callback){
        serviceObj.dialogType = 'alert';
        serviceObj.currentDialog = new Dialog();
        serviceObj.currentDialog.title = alertMessageTitle ? alertMessageTitle  : $translate.instant('Alert');
        serviceObj.currentDialog.payload = {content: alertMessageText};
        serviceObj.currentDialog.template = 'icm-gaf-legacy/views/partials/dialog_alert';
        serviceObj.currentDialog.callback = callback || function () {};
        serviceObj.currentDialog.callbackOnCancel = true;
        serviceObj.showDialog();
    };


    serviceObj.getRootElement = function(){
        return serviceObj.mainDialog;
    };
    serviceObj.setRootElement = function(element){
        serviceObj.mainDialog = element;
    };


    serviceObj.dialog = function(options, template, payload, callback, initFunction, validateFunction, callbackOnCancel, customDialogCss){
        // GYDA-3460 The following timeout was added to address this issue.
        // This is not ideal solution but necessary to handle scenarios where there are back to back dialogs.
        // The only reason we did it this way for now is because of the use of nested $timeout in the dialog.js contentLoaded function.
        // This timeout delay was apparently needed for some other purpose but caused issue when having back to back dialogs.
        // This was a quick fix before the H1C release.
        // GYDA-3513 was created to handle addressing this a better way in the future.

        var deferred = $q.defer();
        $timeout(function() {
            var optionsType = Object.prototype.toString.call(options);
            serviceObj.dialogType = 'message';
            serviceObj.currentDialog = new Dialog();
            if(customDialogCss) {
                serviceObj.currentDialog.customDialogCss = customDialogCss;
            }

            if(optionsType === '[object String]' || optionsType === '[object Null]'){
                serviceObj.currentDialog.title = options;
                serviceObj.currentDialog.template = template;
                serviceObj.currentDialog.callbackOnCancel = angular.isDefined(callbackOnCancel) && callbackOnCancel === true;
                if(angular.isDefined(payload) && angular.isDefined(payload.wrapperTemplate)) {
                    serviceObj.currentDialog.wrapperTemplate = payload.wrapperTemplate;
                }
                if(angular.isDefined(payload)){
                    serviceObj.currentDialog.payload = payload;
                }
                if(angular.isDefined(callback)){
                    serviceObj.currentDialog.callback = callback;
                }
                if(angular.isDefined(initFunction)){
                    serviceObj.currentDialog.init = initFunction;
                }
                if(angular.isDefined(validateFunction)){
                    serviceObj.currentDialog.validate = validateFunction;
                }
            }else if(optionsType === '[object Object]'){
                //Supports function overloading via an object, making it easier for us to add
                //options to the dialog at a later point.
                serviceObj.currentDialog.callbackOnCancel = false;
                serviceObj.currentDialog = angular.extend(serviceObj.currentDialog, options);
            }

            serviceObj.showDialog();

            $timeout(function(){
                deferred.resolve();
            }, 500);
        },200);

        return deferred.promise;
    };

    serviceObj.confirm = function(confirmMessageText, confirmMessageTitle, options){
        var callback;

        // This supports an older method of calling DialogService.confirm with a callback directly.
        if (typeof options === 'function') {
            callback = options;
            options = {};
        } else {
            options = options || {};
            callback = options.callback || function() {};
        }

        var okText = options.okText || 'OK',
            cancelText = options.cancelText || 'Cancel';


        serviceObj.dialogType = 'confirm';
        serviceObj.currentDialog = new Dialog();
        serviceObj.currentDialog.title = confirmMessageTitle ? confirmMessageTitle  : $translate.instant('Alert');
        serviceObj.currentDialog.payload = {
            content: confirmMessageText,
            okText: okText,
            cancelText: cancelText};

        serviceObj.currentDialog.template = 'icm-gaf-legacy/views/partials/dialog_confirm';
        serviceObj.currentDialog.callbackOnCancel = true;
        serviceObj.currentDialog.callback = callback;
        serviceObj.showDialog();
    };

    serviceObj.confirmExit = function (options, payload, callback) {

        var dialogOptions = {
            callbackOnCancel: false,
            init: null,
            title: $translate.instant('Leave Page?'),
            validate: null,
            customDialogCss: {}
        };

        angular.extend(dialogOptions, options);

        serviceObj.dialog(
            dialogOptions.title,
            'icm-gaf-legacy/views/partials/dialog_confirm_exit',
            angular.extend({
                content:$translate.instant('You are about to leave the page. Any unsaved changes will be lost.'),
                confirm:$translate.instant('Save'),
                cancel:$translate.instant('Cancel'),
                reject:$translate.instant('Don\'t Save')
            }, payload),
            callback || function () {},
            dialogOptions.init,
            dialogOptions.validate,
            dialogOptions.callbackOnCancel,
            dialogOptions.customDialogCss);
    };

    serviceObj.showDialog = function(){

        if(serviceObj.dialogChanging.length > 0){
            for(var i = 0; i < serviceObj.dialogChanging.length; i++){
                serviceObj.dialogChanging[i](serviceObj.currentDialog);
            }
        }
        angular.element('body:not(".noScroll")').addClass('noScroll');
    };
    serviceObj.closeDialog = function() {

        if(serviceObj.dialogChanging.length > 0){
            for(var i = 0; i < serviceObj.dialogChanging.length; i++){
                serviceObj.dialogChanging[i]();
            }
        }
        angular.element('body.noScroll').removeClass('noScroll');
    };
    serviceObj.clearCallbacks = function() {
        if(serviceObj.currentDialog) {
            serviceObj.currentDialog.callback = null;
            serviceObj.currentDialog.init = null;
            serviceObj.currentDialog.validate = null;
        }
    };
    /**
     * Shows a "flash" message at the top of the screen that can show various types of information. This is a rather raw
     * method. There are flashAlert/flashSuccess/flashError methods to show a specific type of flash. Use those.
     * @param {string} text The text of the message.
     * @param {string} type What type of message. (alert/warning/success/error/info) This is provided by the shortcut methods.
     * @param {number} timeout How long until this thing disappears. (0 to disable)
     * @param {Object} options A variety of options to impact the message. Summarized below:
     * @param {string} options.class The name of a class (or space-separated list of classes) to apply to the .info-box div on the element. (Allows you to style your info box differently).
     * @param {string} options.icon The name of an icon-font icon to show at the left of the message.
     * @param {string} options.hideOnPageChange If set to true, this flash message will disappear whenever the user navigates to a new page. If false, it will stick around forever. (Or until its timeout expires)
     * @param {string} options.uniqueId If set to a string value, only one flash message with the given id will be shown on the screen at a time. Newer messages will replace older ones.
     * @returns {number} The id of the message, which can later be used to remove it programmatically.
     */
    serviceObj.flash = function(text, type, timeout, options) {

        options = options || {};
        type = type || 'info'; // one of: error, success, info, alert
        timeout = typeof timeout !== 'undefined' ? timeout : 5; // 0 to disable.
        var messageId = currentFlashMessageId++;

        if (typeof options.uniqueId !== 'undefined') {
            for (var i = 0; i < serviceObj.flashMessages.length; i++) {
                if (serviceObj.flashMessages[i].uniqueId === options.uniqueId) {
                    serviceObj.flashMessages.splice(i, 1);
                    i--; // We modified the array. Iterate over the element in our place. (If there is one)
                }
            }
        }

        serviceObj.flashMessages.push({
            id: messageId,
            uniqueId: options.uniqueId,
            type: type,
            timeout: timeout,
            text: text,
            className: options.class || '',
            iconName: options.icon,
            hideOnPageChange: options.hideOnPageChange || false
        });
        return messageId;
    };

    /**
     * Show an error message at the top of the page.
     * @see {@link flash} for options and parameters.
     */
    serviceObj.flashError = function flashError(text, timeout, options) {

        // if there is no supplied uniqueId, use the text
        // will force us to only show 1 flash error per string message
        options = options || {};
        options.uniqueId = options.uniqueId || text;

        return this.flash(text, 'error', timeout, options);
    };
    /**
     * Show an error message at the top of the page.
     * @see {@link flash} for options and parameters.
     */
    serviceObj.flashAlert = function flashAlert(text, timeout, options) {
        return this.flash(text, 'alert', timeout, options);
    };
    /**
     * Show a warning message at the top of the page.
     * @see {@link flash} for options and parameters.
     */
    serviceObj.flashWarning = function flashWarning(text, timeout, options) {
        return this.flash(text, 'warning', timeout, options);
    };
    /**
     * Show an informational message at the top of the page.
     * @see {@link flash} for options and parameters.
     */
    serviceObj.flashInfo = function flashInfo(text, timeout, options) {
        return this.flash(text, 'info', timeout, options);
    };
    /**
     * Show a success message at the top of the page.
     * @see {@link flash} for options and parameters.
     */
    serviceObj.flashSuccess = function flashSuccess(text, timeout, options) {

        return this.flash(text, 'success', timeout, options);
    };

    /**
     * Remove a flash message programatically.
     * @param id The id of the message. (This is returned by the various "flash" methods)
     * @returns {boolean} True if we were able to remove the method; false otherwise.
     */
    serviceObj.removeFlash = function removeFlash(id) {

        for (var i = 0; i < serviceObj.flashMessages.length; i++) {
            if (serviceObj.flashMessages[i].id === id) {
                serviceObj.flashMessages.splice(i, 1);
                return true;
            }
        }
        return false;
    };

    serviceObj.getFlashMessage = function getFlashMessage(id) {

        for (var i = 0; i < serviceObj.flashMessages.length; i++) {
            if (serviceObj.flashMessages[i].id === id) {
                return serviceObj.flashMessages[i];
            }
        }
        return null;
    };

    serviceObj.removeFlashMessageByClassName = function removeFlashMessageByClassName(_className) {

       var flashArray = serviceObj.flashMessages;
        for (var i = 0; i < flashArray.length; i++) {
            if (flashArray[i].className === _className) {
                serviceObj.removeFlash(flashArray[i].id);
            }
        }
    };
    return serviceObj;
}]);
